<div appDialogSelectable appDialogKeyboardEnabled [appDialogMinimizable]="MinimizableDialogType.Task">
  <mat-dialog-content (cdkDragStarted)="dialogBoundryService.handleDragStart($event)" (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
    <div appDialogDragArea cdkDragHandle></div>
    <app-task-modal-static [taskViewModel]="data.taskViewModel" [taskModalModeEnum]="data.taskModalMode" (openServiceEditDialog)="onOpenServiceEditDialog($event)" (closed)="close()"></app-task-modal-static>
  </mat-dialog-content>
</div>
